import type { PayloadAction } from '@reduxjs/toolkit';
import { createSelector, createSlice } from '@reduxjs/toolkit';
import { RootState } from '@store/create-store';
import { PriceZone } from '@price-card/models/price-zone.model';

export interface PriceZonesState {
  priceZones: PriceZone[];
  isFetching: boolean;
  error?: string;
}

const initialState: PriceZonesState = {
  priceZones: [],
  isFetching: false,
};

export const priceZonesSlice = createSlice({
  name: 'priceZones',
  initialState,
  reducers: {
    retrievePriceZones: state => {
      state.isFetching = true;
    },
    retrievePriceZonesSuccess: (state, action: PayloadAction<PriceZone[]>) => {
      state.priceZones = [...action.payload].sort((a, b) => a.name.localeCompare(b.name) || a.alias.localeCompare(b.alias));
      state.isFetching = false;
    },
    retrievePriceZonesFailure: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.isFetching = false;
    },
  },
});

export type PriceZonesViewModel = {
  priceZones: PriceZone[];
  isFetching: boolean;
  error?: string;
};

export const selectPriceZonesViewModel = createSelector(
  (state: RootState) => state,
  (state): PriceZonesViewModel => ({
    priceZones: state.priceCard.priceZones.priceZones,
    isFetching: state.priceCard.priceZones.isFetching,
    error: state.priceCard.priceZones.error,
  }),
);
export const { retrievePriceZones, retrievePriceZonesSuccess, retrievePriceZonesFailure } =
  priceZonesSlice.actions;

export default priceZonesSlice.reducer;
